const renderFieldsTypeMap = {
  country: 'country',
  data: 'data',
  label: 'label',
  static: 'static',
}
export default renderFieldsTypeMap
